import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {
    generateEventCardBadge,
    generateEventCardBadgeRow,
} from '#core/application/modules/tiles/event-card-badge/index.js';
import {generateEventCardMarketsSlider} from '#core/application/modules/tiles/event-card-markets-slider/index.js';
import {generateEventTimingStatus} from '#core/application/modules/tiles/event-timing-status/index.js';
import {
    generateAvantgardeEventCardInplayScoreAccent,
    generateAvantgardeOddsButton,
} from '#core/application/modules/cards-and-promotions/avantgarde-cards/avantgarde-event-card-common.js';

function generateMatchEventCardAvantgardeDetails(PALETTE, CARD_DETAILS) {
    return {
        eventCard: {
            container: {
                style: {
                    borderColor: PALETTE.FEATURED_ACCENT_BORDER,
                },
            },
            clickableArea: {
                style: {
                    base: {
                        height: 'initial',
                    },
                },
            },
            title: {
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
        sportCountryIcons: {
            sportIcon: {
                icon: {
                    style: {
                        fill: CARD_DETAILS.SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
        },
        headerTime: generateEventTimingStatus(CARD_DETAILS.TIMING_STATUS),
        scoreboard: generateAvantgardeEventCardInplayScoreAccent(CARD_DETAILS),
        gameLineMarketContent: {
            market: {
                headerLabel: {
                    style: CARD_DETAILS.MARKET_NAME_TEXT,
                },
                unavailableMarketText: {
                    style: CARD_DETAILS.ODDS_BUTTON.ODDS_UNAVAILABLE_TEXT,
                },
                selectionButton: generateAvantgardeOddsButton(CARD_DETAILS.ODDS_BUTTON),
            },
        },
    };
}
export function avantgardeMatchCardsFactory(PALETTE, COLOR_MODE) {
    return {
        MatchEventCardAvantgarde: {
            mode: COLOR_MODE,
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            showCustomBackgroundImage: true,
            headerContainer: {
                style: {
                    padding: 8,
                },
            },
            badgeRow: generateEventCardBadgeRow(PALETTE.FEATURED_EVENT_CARD_BADGE),
            categoryBadge: generateEventCardBadge(PALETTE.FEATURED_EVENT_CARD_BADGE),
            marketsSlider: merge(generateEventCardMarketsSlider(PALETTE.FEATURED_EVENT_CARD_MARKETS_SLIDER), {
                container: {
                    createStackingContext: true,
                    style: {
                        padding: '4px 0 6px',
                        ...resolveBackground(PALETTE.PARENT.CARD_CONTAINER_BG),
                    },
                },
                marketTitle: {
                    style: PALETTE.CARD_MARKET_TITLE_TEXT,
                },
                genericMarketContent: {
                    container: {
                        style: {
                            padding: '0 8px',
                            ...resolveBackground('none'),
                        },
                    },
                    market: {
                        selectionButton: generateAvantgardeOddsButton(PALETTE.EVENT_CARD_ODDS_BUTTON),
                    },
                },
            }),
            eventCardDetails: generateMatchEventCardAvantgardeDetails(PALETTE, PALETTE.CARD_EVENT_DETAILS_LIGHT),
            eventCardDetailsDark: generateMatchEventCardAvantgardeDetails(PALETTE, PALETTE.CARD_EVENT_DETAILS_DARK),
        },
    };
}
